@if (searchOptions.length) {
  <mat-form-field
    class="dropdown"
    [appearance]="appearance"
    >
    <mat-select
      [(value)]="selectedOption"
      (valueChange)="optionValue.emit(selectedOption)"
      >
      @for (option of searchOptions; track option) {
        <mat-option [value]="option">{{
          option
        }}</mat-option>
      }
    </mat-select>
  </mat-form-field>
}
<mat-form-field class="search-button" [appearance]="appearance">
  <mat-label>{{ label }}</mat-label>
  <input
    #input
    type="text"
    matInput
    [(ngModel)]="value"
    (ngModelChange)="onChange($event)"
    (keydown.enter)="triggerSearch()"
    />
    @if (!value) {
      <mat-icon
        matSuffix
        class="search-icon"
        (click)="triggerSearch()"
        >search</mat-icon
        >
    }
    @if (value) {
      <mat-icon matSuffix class="search-icon" (click)="clearSearch()"
        >close</mat-icon
        >
      }
    </mat-form-field>
